<template>
  <span>
    <span v-if="params.data.is_remaining"> <!-- This is adset -->
      {{ params.data.name }}
    </span>
    <span v-else>
      <span class="w-16 h-20">
        <video class="inline-block align-middle w-16 h-20 mr-3 mini-ad-image" v-if="!!parseInt(meta.has_video)" :src="meta.file"></video>
        <img v-else class="inline-block align-middle w-16 h-20 mr-3 mini-ad-image" :src="meta.file" :alt="params.data.title">
      </span>
      <span class="align-middle" :title="params.data.title">
        {{ params.data.title }}
      </span>
    </span>
  </span>
</template>

<script>
export default {
  computed: {
    meta () {
      return JSON.parse(this.params.data.frontend_meta || '{}')
    }
  }
}
</script>

<style lang="css">
 .ag-cell-wrapper {
   overflow: hidden !important;
   text-overflow: ellipsis !important;
   white-space: nowrap !important;
 }
  .mini-ad-image {
    border-radius: 13%;
  }
</style>